import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Typo } from "../../typography";
export const Wrapper = styled.div `
  button {
    width: calc(100% + 0.75rem);
    min-width: calc(100% + 0.75rem);
    transform: translateX(-0.75rem);
    padding: 0;
  }
`;
export const FlyoutWrapper = styled.div `
  display: block;
  position: fixed;
  padding: 4.75rem 0 0rem 0;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 22;

  div[tabindex="0"]:after {
    display: none;
  }

  button {
    width: 100%;
  }
`;
export const TitleWrapper = styled.div `
  hr {
    margin: 0.5rem 0;
  }
`;
export const StyledTypo = styled((p) => _jsx(Typo, Object.assign({}, p))) `
  color: ${({ theme }) => theme.colors.grey13};
  padding-left: 0.5rem;
  margin-top: 1.5rem;
  margin-bottom: 0;
`;
export const StyledButtonWrapper = styled.div `
  &&& button {
    min-width: 3.75rem;
    width: fit-content;
    padding-right: 1rem;
  }
`;
